import { useRef, memo } from "react";
import ESIInclude from "@JohnLewisPartnership/jl-esi-components";

export type Props = {
  /**
   * A string representing the product ID from the Product Information Management system.
   */
  pimProductId: string;
  /**
   * A string representing the SKU ID of the product.
   */
  skuId: string;
  /**
   * A string representing the placement of the product.
   */
  placement: string;
  /**
   * A string representing the maximum number of products per page.
   */
  maxProductsPerPage: string;
  /**
   * A string indicating whether refresh is allowed.
   */
  allowRefresh?: string;
  /**
   * A string indicating Recommendation panel type
   */
  type?: "small" | "small-manual-recs";
};

export const RecommendationsUI = memo(function RecommendationsUI({
  placement,
  pimProductId,
  skuId,
  maxProductsPerPage,
  allowRefresh,
  type,
}: Props) {
  const url = useRef(
    `/esi/recommendations/?${new URLSearchParams({
      placement,
      productId: pimProductId,
      skuId,
      ...(type ? { type } : {}),
      maxProductsPerPage,
      allowRefresh: allowRefresh || "false",
      withLoader: "true",
    }).toString()}`,
  );

  return (
    <div
      data-testid={`recommendations-${placement.toLowerCase()}`}
      className="esi-wrapper"
    >
      <ESIInclude
        id={`jl-recommendations-panel-esi-${placement.toLowerCase()}`}
        src={url.current}
      />
    </div>
  );
});
